import { Countdown } from "./Countdown";

export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center px-4 sm:px-6 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://readdy.ai/api/search-image?query=modern%20professional%20hair%20salon%20interior%20with%20elegant%20styling%20stations%2C%20warm%20ambient%20lighting%2C%20contemporary%20design%2C%20luxury%20beauty%20space%2C%20clean%20minimalist%20aesthetic%2C%20soft%20golden%20tones%2C%20professional%20hairdressing%20environment%2C%20sophisticated%20salon%20atmosphere%2C%20high-end%20beauty%20industry%20setting%2C%20premium%20hair%20care%20workspace&width=1920&height=1080&seq=hero-salon-bg-001&orientation=landscape)'
        }}
      ></div>

      <div className="absolute inset-0 bg-black/70"></div>

      <div className="relative z-10 max-w-5xl mx-auto text-center py-20 sm:py-24">
        <div className="inline-block mb-4 sm:mb-6 px-4 sm:px-6 py-2 bg-[#EA9D00] rounded-full">
          <span className="text-[#2A2A2A] font-bold text-xs sm:text-sm md:text-base">LIVE GRATUITA • 09/02</span>
        </div>

        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-black text-white mb-4 sm:mb-6 leading-tight px-2">
          A REVOLUÇÃO DO<br />
          <span className="text-[#EA9D00]">MIX EXPRESS</span><br />
          CHEGOU
        </h1>

        <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-white/95 mb-8 sm:mb-10 md:mb-12 max-w-3xl mx-auto leading-relaxed px-2">
          Descubra como essa tecnologia está transformando salões em todo o Brasil e como você pode sair na frente em 2025
        </p>

        <Countdown targetDate="2026-02-09T19:00:00" />

        <div className="h-4 sm:h-8"></div>

        <a
          href="https://chat.whatsapp.com/HlxOc0MOTd992aTE1YYBIN?mode=gi_t"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block bg-[#EA9D00] text-[#2A2A2A] font-bold text-sm sm:text-base md:text-lg lg:text-xl px-6 sm:px-10 md:px-14 lg:px-16 py-3 sm:py-4 md:py-5 rounded-full hover:bg-[#d89000] transition-all duration-300 shadow-2xl hover:shadow-3xl hover:scale-105 whitespace-nowrap cursor-pointer"
        >
          GARANTIR MINHA VAGA GRATUITA
        </a>

        <p className="text-white/80 text-xs sm:text-sm md:text-base mt-6 sm:mt-8 px-2">
          ⏰ Vagas limitadas • Cadastre-se agora
        </p>
      </div>
    </section>
  );
}
